import React, {FC, forwardRef} from 'react';
import {Tooltip as MuiTooltip, TooltipProps as MuiTooltipProps} from '@material-ui/core';

const ENTER_TOUCH_DELAY = 0;
const LEAVE_TOUCH_DELAY = 20000;

export const preventBubbling = e => {
    e.stopPropagation();
};

export type TooltipProps = MuiTooltipProps;

const Tooltip: FC<TooltipProps> = forwardRef(
    ({PopperProps, children, onOpen = () => {}, onClose = () => {}, ...props}, ref) => {
        const [open, setOpen] = React.useState(false);

        const handleClose = event => {
            setOpen(false);
            onClose(event);
        };

        const handleOpen = event => {
            if (event.type === 'mouseover') {
                setOpen(true);
            } else {
                // Overwrite default Tooltip behaviour to make it possible to close
                // tooltip by clicking children element again for touch devices
                setOpen(!open);
            }
            onOpen(event);
        };

        return (
            <MuiTooltip
                ref={ref}
                interactive
                open={open}
                onClose={handleClose}
                onOpen={handleOpen}
                PopperProps={{
                    onClick: preventBubbling,
                    ...PopperProps
                }}
                enterTouchDelay={ENTER_TOUCH_DELAY}
                leaveTouchDelay={LEAVE_TOUCH_DELAY}
                {...props}>
                <span>{children}</span>
            </MuiTooltip>
        );
    }
);

export default Tooltip;
